import { AtomEffect } from 'recoil';

export const localStorageEffect = (key: string): AtomEffect<any> => ({ setSelf, onSet }) => {
  // Load the saved value from localStorage
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    try {
      setSelf(JSON.parse(savedValue));
    } catch (error) {
      console.error('Error parsing localStorage value:', error);
      // If parsing fails, clear the invalid data
      localStorage.removeItem(key);
    }
  }

  // Subscribe to state changes and save to localStorage
  onSet((newValue, _, isReset) => {
    if (isReset || newValue === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(newValue));
    }
  });
};
